import restUrls from "web/constants/restUrls";
import storageNames from "web/constants/storageNames";
import BrowserPersistence from "web/utils/system/storage/storage/browserPersistence";

import api from "../api/apiSlice";

export const intercomApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getIntercomToken: builder.query<{ token: string }, void>({
      queryFn: async () => {
        try {
          const storage = new BrowserPersistence();
          const token = storage.getItem(storageNames.tokenAccess);

          const response = await fetch(
            `${process.env.ISTIO_GATEWAY}${restUrls.intercomToken}`,
            {
              headers: {
                ...(token && { Authorization: `Bearer ${token}` }),
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            }
          );

          if (!response.ok) {
            return { error: { status: response.status, data: await response.text() } };
          }

          const data = await response.json();

          return { data };
        } catch (error) {
          return { error: { status: "FETCH_ERROR", error: String(error) } };
        }
      },
      providesTags: ["IntercomToken"],
    }),
  }),
});

export const { useGetIntercomTokenQuery } = intercomApiSlice;
